/**
 * Account model.
 */
export default {
  fields: {
    id: 0,
    name: '',
    users: [],
    enabled: true,
  },
  getDefaults() {
    return JSON.parse(JSON.stringify(this.fields));
  },
  /**
   * Returns completed fields from a response.
   * @param response
   */
  fromApiResponse(response) {
    return {
      id: response.id,
      name: response.name,
      users: response.users,
      enabled: response.is_active,
    };
  },
  /**
   * Return an object for sending to a API
   * @param modal
   */
  toApiRequest(model) {
    return {
      name: model.name,
      is_active: model.enabled,
    };
  },
};
